import {
  trigger,
  transition,
  group,
  query,
  style,
  animate,
  animateChild
} from "@angular/animations";

export class NavigatorAnimations {
  static routeHomeSlide = trigger("homeSlide", [
    transition("HomePage => *", [
      style({ position: 'relative' }),
      query(':enter, :leave', 
        [
          style({
            position: 'absolute',
            width: '100%',
            height: '100%'
          })
        ], 
        { optional: true }
      ),
      group([
        query(
          ":enter",
          [
            style({ transform: "translateX(100%)" }),
            animate("0.4s ease-in-out", style({ transform: "translateX(0%)" })),
            animateChild()
          ],
          { optional: true }
        ),
        query(
          ":leave",
          [
            style({ opacity: 1 }),
            animate(
              "0.4s ease-in-out",
              style({ opacity: 0 })
            ),
            animateChild()
          ],
          { optional: true }
        )
      ])
    ])
  ]);
  
  static routeSlide = trigger("routeSlide", [
    transition(":increment", [
      style({ position: 'relative', overflow: 'hidden' }),
      query(':enter, :leave', 
        [
          style({
            position: 'absolute',
            width: '100%',
            height: '100%'
          })
        ], 
        { optional: true }
      ),
      group([
        query(
          ":enter",
          [
            style({ transform: "translateX(100%)" }),
            animate("0.4s ease-in-out", style({ transform: "translateX(0%)" })),
            animateChild()
          ],
          { optional: true }
        ),
        query(
          ":leave",
          [
            style({ transform: "translateX(0%)" }),
            animate(
              "0.4s ease-in-out",
              style({ transform: "translateX(-100%)" })
            ),
            animateChild()
          ],
          { optional: true }
        )
      ])
    ]),
    transition(":decrement", [
      style({ position: 'relative', overflow: 'hidden' }),
      query(':enter, :leave', [
        style({
          position: 'absolute',
          width: '100%',
          height: '100%'
        })
      ]),
      group([
        query(
          ":enter",
          [
            style({ transform: "translateX(-100%)" }),
            animate("0.4s ease-in-out", style({ transform: "translateX(0%)" })),
            animateChild()
          ],
          { optional: true }
        ),
        query(
          ":leave",
          [
            style({ transform: "translateX(0%)" }),
            animate(
              "0.4s ease-in-out",
              style({ transform: "translateX(100%)" })
            ),
            animateChild()
          ],
          { optional: true }
        )
      ])
    ])
  ]);
}
